module.exports = __webpack_public_path__ + "static/img/基因检测.0a04f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/一级标题Banner/基因检测.jpg
// module id = 5G3i
// module chunks = 16